import { useState, type FormEvent } from "react";
import { api } from "./api";

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password, username || undefined);
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col justify-center px-5 py-10">
      <div className="animate-fade-up">
        <p className="text-xs font-medium tracking-[0.2em] text-[color:var(--color-pine)] uppercase">
          Staging · Foreclosure
        </p>
        <h1 className="mt-2 font-[family-name:var(--font-display)] text-4xl leading-tight text-[color:var(--color-ink)] sm:text-5xl">
          Newark Law Offices
        </h1>
        <p className="mt-3 max-w-md text-[color:var(--color-ink-soft)]">
          Foreclosure notice queue and mailing labels. Sign in with Basic Auth credentials to review
          stages and print Avery / DYMO batches.
        </p>
      </div>

      <form
        onSubmit={onSubmit}
        className="animate-fade-up-delay mt-8 space-y-4 border-t border-[color:var(--color-pine)]/25 pt-8"
      >
        <label className="block text-sm font-medium text-[color:var(--color-ink)]">
          Username
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Optional if server default matches"
            className="mt-1.5 w-full rounded-md border border-[color:var(--color-ink)]/15 bg-white/75 px-3 py-2.5 outline-none ring-[color:var(--color-pine)]/30 focus:ring-2"
          />
        </label>
        <label className="block text-sm font-medium text-[color:var(--color-ink)]">
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 w-full rounded-md border border-[color:var(--color-ink)]/15 bg-white/75 px-3 py-2.5 outline-none ring-[color:var(--color-pine)]/30 focus:ring-2"
            required
          />
        </label>
        {error ? <p className="text-sm text-[color:var(--color-danger)]">{error}</p> : null}
        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-[color:var(--color-pine)] px-4 py-2.5 font-medium text-white transition hover:bg-[color:var(--color-pine-deep)] disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
